module.exports = __webpack_public_path__ + "static/reportfactory-6ae023fd07c261e32bf32a3e020c7d08.jpg";